(() => {
  'use strict';

  if (window.PensualizeiProductCleanV3) return;
  window.PensualizeiProductCleanV3 = true;

  const SECTION_SELECTOR = '[data-ps-product-clean-v3]';
  const GROUP_SELECTOR = '[data-ps-option-count]';
  const VALUE_SELECTOR = '[data-ps-option-value]';
  const VARIANTS_SELECTOR = '[data-ps-variants]';
  const MAIN_BUTTON_SELECTOR = '[data-ps-main-submit]';
  const MAIN_LABEL_SELECTOR = '[data-ps-main-submit-label]';
  const HELP_SELECTOR = '[data-ps-choice-help]';
  const MOBILE_BAR_SELECTOR = '[data-ps-mobile-buybar]';
  const MOBILE_BUTTON_SELECTOR = '[data-ps-mobile-buybar-button]';

  const groups = (section) =>
    Array.from(section.querySelectorAll(GROUP_SELECTOR));

  const requiredGroups = (section) =>
    groups(section).filter((group) => Number(group.dataset.psOptionCount || 0) > 1);

  const variants = (section) => {
    const node = section.querySelector(VARIANTS_SELECTOR);
    if (!node) return [];

    try {
      return JSON.parse(node.textContent || '[]');
    } catch (error) {
      console.warn('[Pensualizei] Não foi possível ler as variantes.', error);
      return [];
    }
  };

  const selectedValues = (section) =>
    groups(section).map((group) => {
      const checked = group.querySelector(`${VALUE_SELECTOR}:checked`);
      const count = Number(group.dataset.psOptionCount || 0);

      if (count <= 1) {
        return checked?.value || group.querySelector(VALUE_SELECTOR)?.value || null;
      }

      return group.dataset.psChosen === 'true' ? checked?.value || null : null;
    });

  const variantMatches = (variant, values) =>
    Array.isArray(variant.options) &&
    variant.options.every((value, index) => {
      return values[index] == null || values[index] === value;
    });

  const exactVariant = (section) => {
    const values = selectedValues(section);
    if (values.some((value) => value == null)) return null;

    return variants(section).find((variant) => {
      return (
        variant.available &&
        Array.isArray(variant.options) &&
        variant.options.every((value, index) => value === values[index])
      );
    }) || null;
  };

  const formatMoney = (cents) => {
    const value = Number(cents);
    if (!Number.isFinite(value)) return '';

    try {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'BRL'
      }).format(value / 100);
    } catch {
      return `R$ ${(value / 100).toFixed(2).replace('.', ',')}`;
    }
  };

  const variantInput = (section) =>
    section.querySelector(
      'product-form form[data-type="add-to-cart-form"] input[name="id"]'
    ) ||
    section.querySelector(
      '.product-form form[data-type="add-to-cart-form"] input[name="id"]'
    );

  const setCurrentLabel = (group, value = '') => {
    const node = group.querySelector('[data-ps-option-current]');
    if (node) node.textContent = value ? `— ${value}` : '';
  };

  const setChosen = (group, chosen) => {
    group.dataset.psChosen = String(chosen);
    group.classList.toggle('is-ps-chosen', chosen);

    if (!chosen && Number(group.dataset.psOptionCount || 0) > 1) {
      group.querySelectorAll(VALUE_SELECTOR).forEach((radio) => {
        radio.checked = false;
      });
      setCurrentLabel(group, '');
    }
  };

  const clearConflictingSelections = (section, protectedGroup) => {
    const current = selectedValues(section);
    const hasMatch = variants(section).some((variant) => {
      return variant.available && variantMatches(variant, current);
    });

    if (hasMatch) return;

    groups(section).forEach((group) => {
      if (group === protectedGroup) return;
      if (Number(group.dataset.psOptionCount || 0) <= 1) return;
      setChosen(group, false);
    });
  };

  const showVariantMedia = (section, variant) => {
    const mediaId = variant?.featured_media?.id;
    const sectionId = section.dataset.section;

    if (!mediaId || !sectionId) return;

    const thumbnailItem = section.querySelector(
      `[data-target="${CSS.escape(sectionId)}-${CSS.escape(String(mediaId))}"]`
    );

    const thumbnail =
      thumbnailItem?.querySelector('button.thumbnail') ||
      thumbnailItem?.querySelector('[aria-controls^="GalleryViewer"]');

    thumbnail?.click();
  };

  const updateAvailability = (section) => {
    const allVariants = variants(section);
    const allGroups = groups(section);
    const current = selectedValues(section);

    allGroups.forEach((group, groupIndex) => {
      group.querySelectorAll(VALUE_SELECTOR).forEach((radio) => {
        const candidate = [...current];
        candidate[groupIndex] = radio.value;

        const possible = allVariants.some((variant) => {
          return variant.available && variantMatches(variant, candidate);
        });

        radio.disabled = !possible;
        radio.setAttribute('aria-disabled', String(!possible));

        const label = section.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
        label?.classList.toggle('is-unavailable', !possible);

        if (!possible && radio.checked) {
          radio.checked = false;
          setChosen(group, false);
        }
      });
    });
  };

  const missingGroups = (section) =>
    requiredGroups(section).filter((group) => {
      return (
        group.dataset.psChosen !== 'true' ||
        !group.querySelector(`${VALUE_SELECTOR}:checked`)
      );
    });

  const groupName = (group) =>
    (group.dataset.psOptionName || 'opção')
      .trim()
      .toLocaleLowerCase('pt-BR');

  const missingText = (missing) => {
    const names = missing.map(groupName);

    if (!names.length) return '';
    if (names.length === 1) return `Escolha ${names[0]}`;

    return `Escolha ${names.slice(0, -1).join(', ')} e ${names.at(-1)}`;
  };

  const syncMobileBar = (section) => {
    const bar = section.querySelector(MOBILE_BAR_SELECTOR);
    const mobileButton = bar?.querySelector(MOBILE_BUTTON_SELECTOR);
    const mobileLabel = mobileButton?.querySelector(
      '[data-ps-mobile-buybar-label]'
    );
    const mobilePrice = bar?.querySelector('[data-ps-mobile-price]');
    const mainButton = section.querySelector(MAIN_BUTTON_SELECTOR);
    const selected = exactVariant(section);
    const missing = missingGroups(section);

    if (!bar || !mobileButton || !mobileLabel || !mainButton) return;

    if (missing.length) {
      mobileButton.disabled = false;
      mobileButton.removeAttribute('aria-disabled');
      mobileLabel.textContent = 'Escolher opções';
    } else if (!selected) {
      mobileButton.disabled = true;
      mobileButton.setAttribute('aria-disabled', 'true');
      mobileLabel.textContent = 'Indisponível';
    } else {
      mobileButton.disabled = mainButton.disabled;
      mobileButton.setAttribute('aria-disabled', String(mainButton.disabled));
      mobileLabel.textContent = 'Comprar';

      if (mobilePrice) {
        mobilePrice.textContent = formatMoney(selected.price);
      }
    }
  };

  const syncState = (section) => {
    const button = section.querySelector(MAIN_BUTTON_SELECTOR);
    const label = button?.querySelector(MAIN_LABEL_SELECTOR);
    const help = section.querySelector(HELP_SELECTOR);
    const input = variantInput(section);

    if (!button || !label || !input || button.classList.contains('loading')) {
      return;
    }

    const missing = missingGroups(section);

    if (missing.length) {
      input.disabled = true;
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      label.textContent = 'Escolha as opções';

      if (help) help.textContent = `${missingText(missing)}.`;

      syncMobileBar(section);
      return;
    }

    const selected = exactVariant(section);

    if (!selected) {
      input.disabled = true;
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      label.textContent = 'Escolha outra combinação';

      if (help) {
        help.textContent = 'Essa combinação evaporou. Escolha outra opção.';
      }

      syncMobileBar(section);
      return;
    }

    input.value = String(selected.id);
    input.disabled = false;
    button.disabled = false;
    button.removeAttribute('aria-disabled');
    label.textContent = `Comprar — ${formatMoney(selected.price)}`;

    if (help) help.textContent = 'Pronto para adicionar ao carrinho.';

    const url = new URL(window.location.href);
    url.searchParams.set('variant', String(selected.id));
    window.history.replaceState({}, '', url);

    showVariantMedia(section, selected);

    section.dispatchEvent(
      new CustomEvent('pensualizei:variant-change', {
        bubbles: true,
        detail: { variant: selected }
      })
    );

    syncMobileBar(section);
  };

  const chooseRadio = (section, radio) => {
    if (!radio || radio.disabled) return;

    const group = radio.closest(GROUP_SELECTOR);
    if (!group) return;

    radio.checked = true;
    setChosen(group, true);
    setCurrentLabel(group, radio.value);

    clearConflictingSelections(section, group);
    updateAvailability(section);
    syncState(section);

    radio.dispatchEvent(
      new CustomEvent('pensualizei:option-selected', {
        bubbles: true,
        detail: {
          optionIndex: Number(radio.dataset.psOptionIndex || 0),
          value: radio.value
        }
      })
    );
  };

  const initChoices = (section) => {
    groups(section).forEach((group) => {
      const count = Number(group.dataset.psOptionCount || 0);
      const first = group.querySelector(VALUE_SELECTOR);

      if (count <= 1 && first) {
        first.checked = true;
        setChosen(group, true);
        setCurrentLabel(group, first.value);
      } else {
        setChosen(group, false);
      }
    });

    section.addEventListener('click', (event) => {
      const label = event.target.closest('label.ps-option-pill');
      if (!label || !section.contains(label)) return;

      const radio = label.htmlFor
        ? document.getElementById(label.htmlFor)
        : null;

      if (!radio || !section.contains(radio)) return;

      event.preventDefault();
      chooseRadio(section, radio);
    });

    section.addEventListener('keydown', (event) => {
      const label = event.target.closest('label.ps-option-pill');
      if (!label || !section.contains(label)) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const radio = label.htmlFor
        ? document.getElementById(label.htmlFor)
        : null;

      if (!radio || !section.contains(radio)) return;

      event.preventDefault();
      chooseRadio(section, radio);
    });

    section.querySelectorAll('label.ps-option-pill').forEach((label) => {
      label.tabIndex = 0;
      label.setAttribute('role', 'button');
    });

    updateAvailability(section);
    syncState(section);
  };

  const initAccordions = (section) => {
    const items = Array.from(
      section.querySelectorAll('.product__accordion details')
    );

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        items.forEach((other) => {
          if (other !== item && other.open) {
            other.removeAttribute('open');
          }
        });
      });
    });
  };

  const initReviews = (section) => {
    const link = section.querySelector('.ps-review-badge-link');
    const reviews = section.querySelector('#ps-product-reviews');

    if (!link || !reviews) return;

    const badge = link.querySelector('.jdgm-prev-badge');
    const rating = Number(badge?.dataset?.averageRating || 0);
    const count = Number(badge?.dataset?.numberOfReviews || 0);

    if (!rating || !count) {
      link.hidden = true;
      return;
    }

    link.addEventListener('click', (event) => {
      event.preventDefault();
      reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  const initMobileBar = (section) => {
    const bar = section.querySelector(MOBILE_BAR_SELECTOR);
    const mobileButton = bar?.querySelector(MOBILE_BUTTON_SELECTOR);
    const mainButton = section.querySelector(MAIN_BUTTON_SELECTOR);

    if (!bar || !mobileButton || !mainButton) return;

    let mainVisible = true;

    const updateVisibility = () => {
      const sectionRect = section.getBoundingClientRect();
      const show =
        window.matchMedia('(max-width: 749px)').matches &&
        !mainVisible &&
        window.scrollY > 160 &&
        sectionRect.bottom > 85;

      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      document.body.classList.toggle('ps-mobile-buybar-visible', show);
    };

    new IntersectionObserver(
      ([entry]) => {
        mainVisible = entry.isIntersecting;
        updateVisibility();
      },
      { threshold: 0.18 }
    ).observe(mainButton);

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });

    mobileButton.addEventListener('click', () => {
      const missing = missingGroups(section);

      if (missing.length) {
        missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        missing[0].querySelector('label.ps-option-pill')?.focus();
        return;
      }

      if (!mainButton.disabled) mainButton.click();
    });

    syncMobileBar(section);
    updateVisibility();
  };

  const initSection = (section) => {
    if (section.dataset.psCleanReady === 'v3') return;
    section.dataset.psCleanReady = 'v3';

    initChoices(section);
    initAccordions(section);
    initReviews(section);
    initMobileBar(section);
  };

  const init = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
